/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo, useState } from 'react';

export interface IChatNavigation {
  navigate: (routeName: string, params?: Record<string, unknown>) => void;
  goBack?: () => void;
  canGoBack?: () => boolean;
}

export interface IChatContext {
  healthExToken?: string | boolean | null;
  setHealthExToken?: (token: string | null) => void;
}

const ChatContext = createContext<IChatContext | null>(null);

export const ChatProvider = ({ children }: { children: React.ReactNode }) => {
  const [healthExToken, setHealthExToken] = useState<string | null>(null);
  const value = useMemo<IChatContext>(
    () => ({
      healthExToken,
      setHealthExToken,
    }),
    [healthExToken],
  );

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
};

export const useChatContext = (): IChatContext => {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
};
